import styled from '@emotion/styled';

export const RequestFormContainer = styled.div`
    max-width: 1150px;
    margin: 0 auto;
    poistion: relative;

    .requestFormSelectWrapper {
        width: 100%;

        select {
            text-align: left;
            text-align-last: left;
        }
    }

    .travelersSelectContainer__child .requestFormSelectWrapper {
        width: auto;
    }

    .selectedCabinOverview {
        margin-bottom: 0;
    }
`;

export const RequestFormContent = styled.div`
    position: relative;
    padding: 24px;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    background: #fff;
`;

export const RequestFormLeftSide = styled.section`
    flex: 2;
    padding-right: 24px;
    display: flex;
    flex-direction: column;

    > div {
        margin-bottom: 24px;
    }

    .requestFormContainer__cabineType {
        padding-top: 0;
    }
`;

export const RequestFormRightSide = styled.section`
    flex: 1;
    padding-left: 24px;
    min-width: 400px;
    max-width: 400px;

    .reqFormSummaryContainer {
        padding: 0;
    }

    #requestFormContainer__price
        #requestFormContainer__price__soldout
        #requestFormContainer__price__soldout-contacts
        #requestFormContainer__price__soldout-contacts__container {
        display: block;
    }
`;

export const SectionHeader = styled.p`
    font-weight: bold;
    font-size: 16px;
`;

export const SectionContainer = styled.div``;

export const Separator = styled.div`
    height: 2px;
    margin: 36px 0;
    background: ${({ theme }) => theme.colors.whiteSmoke[100]};
`;
